import { Component } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { MatDialogContent, MatDialogActions, MatDialogTitle, MatDialogClose } from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';

@Component({
	selector: 'lvr-select-disability-kind-dialog',
	template: `
		<h2 mat-dialog-title>{{ 'assignment.phase.disability_kind_dialog.title' | transloco }}</h2>
		<mat-dialog-content>
			<p>{{ 'assignment.phase.disability_kind_dialog.message' | transloco }}</p>
		</mat-dialog-content>
		<mat-dialog-actions align="end">
			<button matButton="filled" class="lvr-secondary" mat-dialog-close>
				{{ 'base.button.cancel' | transloco }}
			</button>
			<button matButton="filled" color="warn" [mat-dialog-close]="true">
				{{ 'assignment.phase.disability_kind_dialog.go_to_edit' | transloco }}
			</button>
		</mat-dialog-actions>
	`,
	imports: [MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose, MatButton, TranslocoPipe],
})
export class LvrSelectDisabilityKindDialog {}
